import { useMemo } from 'react';
import { getArticlesByCategory, getCategoryBySlug } from '@/utils/articles';

export function useCategoryArticles(slug: string) {
  return useMemo(() => {
    const category = getCategoryBySlug(slug);
    const articles = category ? getArticlesByCategory(category.slug) : [];
    return { category, articles, totalCount: articles.length };
  }, [slug]);
}